export enum BusinessCategoryEnum {
  BARBER = 'barber',
  HAIR_STYLIST = 'hair_stylist',
  NAILS = 'nails',
  LASHES = 'lashes',
  MAKEUP = 'makeup',
  SKINCARE = 'skincare',
  TATTOO = 'tattoo',
  MASSAGE = 'massage',
  EYEBROWS = 'eyebrows',
  WAXING = 'waxing',
  COSMETICIAN = 'cosmetician',
  DERMATOLOGY = 'dermatology',
  PHYSIOTHERAPY = 'physiotherapy',
  PERSONAL_TRAINER = 'personal_trainer',
  OTHER = 'other'
}

export enum BusinessSizeEnum {
  SOLO = 'solo',
  SMALL_TEAM = 'small_team',
  SALON = 'salon'
}

export enum CurrentBookingMethodEnum {
  WHATSAPP = 'whatsapp',
  PHONE = 'phone',
  OTHER_APP = 'other_app',
  NONE = 'none'
}

export const businessCategoryLabels: Record<BusinessCategoryEnum, string> = {
  [BusinessCategoryEnum.BARBER]: 'ברבר',
  [BusinessCategoryEnum.HAIR_STYLIST]: 'מעצב/ת שיער',
  [BusinessCategoryEnum.NAILS]: 'מניקור ופדיקור',
  [BusinessCategoryEnum.LASHES]: 'הלחמת ריסים',
  [BusinessCategoryEnum.MAKEUP]: 'איפור',
  [BusinessCategoryEnum.SKINCARE]: 'טיפולי עור ופנים',
  [BusinessCategoryEnum.TATTOO]: 'קעקועים',
  [BusinessCategoryEnum.MASSAGE]: 'עיסוי',
  [BusinessCategoryEnum.EYEBROWS]: 'עיצוב גבות',
  [BusinessCategoryEnum.WAXING]: 'שעווה והסרת שיער',
  [BusinessCategoryEnum.COSMETICIAN]: 'קוסמטיקאית',
  [BusinessCategoryEnum.DERMATOLOGY]: 'דרמטולוגיה',
  [BusinessCategoryEnum.PHYSIOTHERAPY]: 'פיזיותרפיה',
  [BusinessCategoryEnum.PERSONAL_TRAINER]: 'מאמן/ת אישי/ת',
  [BusinessCategoryEnum.OTHER]: 'אחר',
};

export const businessSizeLabels: Record<BusinessSizeEnum, string> = {
  [BusinessSizeEnum.SOLO]: 'עצמאי/ת',
  [BusinessSizeEnum.SMALL_TEAM]: 'צוות קטן (2-4)',
  [BusinessSizeEnum.SALON]: 'סלון (5+)',
};

export const currentBookingMethodLabels: Record<CurrentBookingMethodEnum, string> = {
  [CurrentBookingMethodEnum.WHATSAPP]: 'וואטסאפ',
  [CurrentBookingMethodEnum.PHONE]: 'טלפון',
  [CurrentBookingMethodEnum.OTHER_APP]: 'אפליקציה אחרת',
  [CurrentBookingMethodEnum.NONE]: 'בלי מערכת',
};
